module.exports = __webpack_public_path__ + "img/Dashboard-logo.dc41c280.svg";